/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
function getDocument(iframe: HTMLIFrameElement) {
    return (iframe.contentWindow && iframe.contentWindow.document) || iframe.contentDocument;
}

function isLaunchFrameBroken(frame: HTMLIFrameElement) {
    // if iframe is broken getDocument will throw an exception
    // it could be broken due to 500 error returned for previous app run in IE
    try {
        getDocument(frame);
        return false;
    } catch (e) {
        return true;
    }
}

function createFrame(appToLaunchResType: string): string {
    const frameName = appToLaunchResType + '_frame';
    let launchFrame = document.getElementById(frameName) as HTMLIFrameElement | null;

    if (launchFrame != null && isLaunchFrameBroken(launchFrame)) {
        // null check override: launchFrame is attached to document
        launchFrame.parentNode!.removeChild(launchFrame);
        launchFrame = null;
    }

    if (launchFrame == null) {
        launchFrame = document.createElement('iframe');
        launchFrame.id = frameName;
        launchFrame.name = frameName; // name is used for window.open
        launchFrame.style.visibility = 'hidden';
        launchFrame.hidden = true;
        launchFrame.height = '0';
        document.body.appendChild(launchFrame);
    }

    return frameName;
}

export { createFrame as default, getDocument };
